module.exports = __webpack_public_path__ + "static/media/product_detail_2.90485948.jpg";